import { MoneyCell } from '@ayocore/platform/client/components/EditableGrid';
import type { EditableGridColumn } from '@ayocore/platform/client/components/EditableGrid';
import type { WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey } from './types';

/** Вспомогательная функция округления до 2 знаков. */
function roundMoney(v: number): number {
  return Math.round(v * 100) / 100;
}

export const workOrderAmountColumn: EditableGridColumn<
  WorkOrderRow,
  WorkOrderPatch,
  WorkOrderColumnKey
> = MoneyCell<WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey>({
  key: 'amount',
  title: 'Сумма',
  width: 100,
  value: row => roundMoney(Number(row.qty ?? 0) * Number(row.price ?? 0)),
  editable: false,
  persist: true,
});
